<template>
  <div class="py-4 lg:py-6 px-3 lg:px-6">
    <h1 class="text-green-500 text-3xl font-semibold">Pet Policies</h1>
    <approvals-table></approvals-table>
  </div>
</template>

<script>
import ApprovalsTable from '@/components/Approvals/Pet/ApprovalsTable.vue'
export default {
  components: { ApprovalsTable },
  mounted(){
    
  }
}
</script>

<style>

</style>